import { Component } from '@ecs/Component';

export class Velocity implements Component {
  readonly type = 'Velocity';

  constructor(
    public angle: number = 0,
    public speed: number = 0,
    public maxSpeed: number = Infinity,
    public turnRate: number = 0.1 // radians per frame
  ) {}
}